import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculatePregnancyCompletion(
  patient: Patient | null | undefined,
) {
  const obGynHistory = (patient as any)?.obGynHistory;
  const hasBeenPregnant = obGynHistory?.hasBeenPregnant;

  const hasAnswered = hasBeenPregnant !== undefined && hasBeenPregnant !== null;

  const fields = [hasAnswered];

  const completed = fields.filter(Boolean).length;
  const total = fields.length;

  return {
    percent: total > 0 ? completed / total : 0,
    label: `${completed}/${total} answered`,
    completed,
    total,
  };
}
